// src/services/kpiService.ts
import apiClient from './apiClient';

// Definiamo la struttura esatta dei dati che ci aspettiamo dal backend
export interface KPIMetrics {
  valori_totali: {
    chiamate_ricevute: number;
    minuti_totali: number;
    costo_totale_vapi_eur: number;
    costo_totale_telefonia_eur: number;
    costo_complessivo_eur: number;
  };
  conteggi_azioni: {
    richieste_di_prenotazione: number;
    prenotazioni_completate: number;
    chiamate_trasferite: number;
  };
  medie: {
    soddisfazione_media: number;
    durata_media_secondi: number;
    costo_medio_per_chiamata: number;
  };
}

const getKPIMetrics = async (period: string = 'sempre'): Promise<KPIMetrics> => {
  try {
    const response = await apiClient.get<KPIMetrics>('/api/calls/kpi', {
      params: { period }, // Passa il periodo selezionato come query param
    });
    return response.data;
  } catch (error) {
    console.error(`Errore nel caricamento dei KPI per il periodo ${period}:`, error);
    throw error;
  }
};

export const kpiService = {
  getKPIMetrics,
};